/**
 * Optimizely SDK singleton + helpers. Datafile lives on the ORO assets
 * CDN keyed by SDK key — same URL template as process-runner.
 */

import optimizely from '@optimizely/optimizely-sdk'
import { ENV } from '../env'

type Client = ReturnType<typeof optimizely.createInstance>

let client: Client | null = null

export function getOptimizely(): Client | null {
  if (client) return client
  if (!ENV.optimizelySdkKey) return null
  client = optimizely.createInstance({
    sdkKey: ENV.optimizelySdkKey,
    datafileOptions: {
      urlTemplate: `${ENV.assets}/datafiles/%s.json`,
    },
  })
  return client
}

export async function onOptimizelyReady(): Promise<boolean> {
  const c = getOptimizely()
  if (!c) return false
  try {
    const r = await c.onReady({ timeout: 3_000 })
    return Boolean(r.success)
  } catch {
    return false
  }
}

/** One-shot flag check. For React, prefer `useFeatureFlag` below. */
export function isFeatureEnabled(flagKey: string, userId: string, attrs?: Record<string, unknown>): boolean {
  const c = getOptimizely()
  if (!c) return false
  // optimizely-sdk types userId as string; attrs as Record<string, OptimizelyUserAttributeValue>
  return c.isFeatureEnabled(flagKey, userId, attrs as Record<string, never>) ?? false
}
